import { Component } from '@angular/core';
import { NavController, AlertController, ModalController, NavParams } from 'ionic-angular';
import {ModalContentPage} from '../home/modal';
import { CoolLocalStorage } from 'angular2-cool-storage';
import {AngularFireDatabase,  FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {AngularFireAuth} from 'angularfire2/auth';


@Component({
  selector: 'page-list',
  templateUrl: 'list.html'
})
export class ListPage {
  selectedItem: any;
  cat: Array<any> = [];
  catChk: Array<Boolean> = [];
  dis: Array<String> = [];
  questions: FirebaseListObservable<any[]>;
  ques: FirebaseObjectObservable<any[]>;
  ready: Boolean = true;

  constructor(public  alertCtrl: AlertController, public modalCtrl: ModalController, private afauth: AngularFireAuth, private db: AngularFireDatabase, public navCtrl: NavController, public navParams: NavParams) {

    //this.selectedItem = navParams.get('item');
    this.questions = db.list('/questions', {query: {orderByChild : "cat"}});

    db.list('/questions').subscribe(snapshots=>{
           snapshots.forEach(snapshot => {

              this.ready = false;

              if(this.cat)
              {
                 var chk = this.cat.indexOf(snapshot.cat);

                 if(chk == -1)
                 {
                    this.cat.push(snapshot.cat);
                    this.catChk.push(false);
                    this.dis.push("ndisabled");

                 }

              }
              else
              {
                this.cat.push(snapshot.cat);
                this.catChk.push(false);
                this.dis.push("ndisabled");

              }

           });
       })


  }

  itemTapped(event, item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(ListPage, {
      item: item
    });
  }
  updateList(q, chked, index)
  {

     if(chked == true)
     {
       for(var i = 0; i < this.dis.length ; i++)
       {


          if(i != index)
          {
             this.dis[i] = "disabled";
          }

       }

       this.questions = this.db.list('/questions', {query: {orderByChild : "cat", equalTo : q }});
     }
     else
     {

         for(var i = 0; i < this.dis.length ; i++)
         {


            if(i != index)
            {
               this.dis[i] = "ndisabled";
            }

         }

         this.questions = this.db.list('/questions', {query: {orderByChild : "cat"}});
     }

  }

  edit(q)
  {
    if(q != null)
    {
      let modal = this.modalCtrl.create(ModalContentPage, { ques: q });
      modal.present();
    }
    else
    {
      let modal = this.modalCtrl.create(ModalContentPage);
      modal.present();
    }

  }

  presentConfirm(id) {

    let alert = this.alertCtrl.create({
      title: 'Confirm Delete',
      message: 'Do you want to delete this question?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel');
          }
        },
        {
          text: 'Delete',
          handler: () => {
            this.delete(id);
          }
        }
      ]
    });
    alert.present();
  }

  delete(id)
  {
      this.ques = this.db.object('/questions/' + id);
      this.ques.remove();
  }

}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts